module.exports = __webpack_public_path__ + "img/avatar-6.d3e4903f.svg";